import { Pipe } from '@angular/core';

import { Equipment, Phone, ProductFactory } from '@bytel/bytel-sales';
import { CommercialProposal } from '@bytel/checkout';

import { PriceWithoutCouponPipe } from './price-without-coupon.pipe';

@Pipe({
    name: 'priceFinalEquipment',
    pure: true,
    standalone: true,
})
export class PriceFinalEquipmentPipe extends PriceWithoutCouponPipe {
    /**
     * Transform equipment price with coupon or not
     * @param product Product
     * @param withCoupon Adjust price with coupon or not - false by default
     * @returns Product price
     */
    transform(
        product: Equipment,
        withCoupon: boolean = false,
        deductOdr: boolean = false,
        fundingProposal: CommercialProposal = null,
    ): number {
        let price: number = withCoupon ? product.prices.final : super.transform(product);

        if (fundingProposal) {
            price = fundingProposal.initialAmount;
        }

        if (ProductFactory.Is(product, Phone)) {
            const rsfAmount: number = (product as Phone).rsfAmount ?? 0;
            price = price - rsfAmount;
        }

        if (deductOdr) {
            const odrAmount = product.data?.odr?.amount || 0;
            price -= odrAmount;
        }
        price = Math.max(price, product.minPromoPrice);

        return price;
    }
}
